<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    :class="className"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.2166 4.32639C9.66667 4.82802 9.66667 5.74566 9.66667 7.58016V16.419C9.66667 18.2535 9.66667 19.1712 10.2166 19.6728C10.7664 20.1744 11.6072 20.024 13.2888 19.7224L15.101 19.3976C16.963 19.0632 17.894 18.896 18.447 18.1935C19 17.4903 19 16.4742 19 14.4413V9.55787C19 7.52576 19 6.50971 18.4478 5.80647C17.894 5.10403 16.9622 4.93682 15.1002 4.6032L13.2896 4.27759C11.608 3.97597 10.7672 3.82556 10.2173 4.32719M12 10.5347C12.322 10.5347 12.5833 10.8155 12.5833 11.162V12.8372C12.5833 13.1837 12.322 13.4645 12 13.4645C11.678 13.4645 11.4167 13.1837 11.4167 12.8372V11.162C11.4167 10.8155 11.678 10.5347 12 10.5347Z"
      fill="white"
      fill-opacity="0.6"
    />
    <path
      d="M8.53656 5.99928C6.93589 6.00168 6.10133 6.03768 5.56933 6.58491C5 7.17054 5 8.11299 5 9.99949V13.9997C5 15.8854 5 16.8279 5.56933 17.4143C6.10133 17.9607 6.93589 17.9975 8.53656 17.9999C8.5 17.5007 8.5 16.9247 8.5 16.3014V7.69777C8.5 7.07374 8.5 6.4977 8.53656 5.99928Z"
      :fill="fillColor"
      fill-opacity="0.6"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ExitIcon',
  props: {
    fillColor: {
      type: String,
      default: '#fff'
    },
    width: {
      type: [Number, String],
      default: 22
    },
    height: {
      type: [Number, String],
      default: 22
    },
    class: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const className = props.class
    return {
      className
    }
  }
})
</script>
